import styled from '@emotion/styled';

export const Separator = styled.hr(({ theme }) => ({
    border: 'none',
    borderTop: theme.general.border,
}));

export default Separator;
